import styled from "styled-components";
import { Box } from "@mui/material";
import { grey } from "@mui/material/colors";

export const MemoriesWrapper = styled(Box)`
	max-width: 1400px;
	margin: 0 auto;
	.private_memory {
		position: absolute;
		top: 5px;
		left: 5px;
		svg {
			width: 18px;
			height: 18px;
			fill: #000;
			background: ${grey[100]};
			padding: 3px;
			border-radius: 5px;
		}
	}

	.album-header {
		display: flex;
		justify-content: center;
		background: #f1f1f1;
		padding: 10px;
		border-radius: 5px;
	}
	.download-btn-wrapper {
		background: #ffffff;
		padding: 10px 5px;
		border-radius: 5px;
		gap: 5px;
	}
	.memory_menu {
		position: absolute;
		right: 5px;
		top: 7px;
		background: ${grey[100]};
		button {
			background: ${grey[100]};
			svg {
				width: 18px;
				height: 18px;
			}
		}
	}
`;

export const LockedMemoriesWrapper = styled(Box)`
	min-height: 60vh;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	padding: 40px 20px;

	.icon_ring {
		width: 88px;
		height: 88px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		background: radial-gradient(circle at 30% 30%, #fdf3d0, #f0d78a 60%, #c9a84c 100%);
		box-shadow: 0 8px 30px rgba(201, 168, 76, 0.35);
		margin-bottom: 14px;

		svg {
			font-size: 34px;
			color: #8b6914;
		}
	}

	.views_value {
		font-size: clamp(48px, 8vw, 72px);
		font-weight: 800;
		line-height: 1;
		background: linear-gradient(135deg, #8b6914, #c9a84c);
		-webkit-background-clip: text;
		background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.views_label {
		font-weight: 700;
		font-size: 13px;
		color: ${({ theme }) => theme.palette.text.secondary};
		text-transform: uppercase;
		letter-spacing: 1.2px;
		margin-top: 8px;
	}

	.teaser_text {
		max-width: 380px;
		color: ${({ theme }) => theme.palette.text.secondary};
		margin: 18px 0 24px;
	}

	.locked_row {
		display: flex;
		gap: 14px;
		margin-bottom: 26px;
	}

	.locked_stat {
		position: relative;
		width: 46px;
		height: 46px;
		border-radius: 12px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: ${({ theme }) => theme.palette.grey[100]};
		color: ${({ theme }) => theme.palette.grey[400]};

		svg:first-child {
			font-size: 20px;
		}

		.lock_badge {
			position: absolute;
			bottom: -6px;
			right: -6px;
			width: 16px;
			height: 16px;
			padding: 2px;
			border-radius: 50%;
			background: #c9a84c;
			color: #fff;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 12px !important;
			box-shadow: 0 0 0 2px #fff;
		}
	}
`;
